/* eslint-disable @typescript-eslint/no-unused-vars */
import { poisBountyAssets } from "assets/cdn";
import classNames from "classnames";
import { usePoisBountyContext } from "components/PoisBountyWidgetV3/context";
import { useGoogleAnalyticsContext, useWebStoreContext } from "contexts";
import { useAppDispatch, useAppSelector, useImagePath } from "hooks";
import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { onScrollToShopSection, selectPoisBountyV3State } from "redux/slices";
import { useMegaMenuRedux } from "redux/slices/mega-menu/hooks/useMegaMenuRedux";
import { getTimeLeft } from "utils/time";
import { ButtonStyled } from "../ClaimButton/styles";
import {
	PurchaseCounter,
	ToShopSectionDesktop,
	ToShopSectionMobile
} from "./styles";

export const ToShopSection = () => {
	const navigate = useNavigate();
	const dispatch = useAppDispatch();
	const { toggleDrawer } = useMegaMenuRedux();
	const { userTracker, nowTime } = useWebStoreContext();
	const { reportPlaygamiEvent } = useGoogleAnalyticsContext();
	const { tracker } = useAppSelector(selectPoisBountyV3State);
	const { getImage } = useImagePath("cdn");
	const { isPageVariant, isPortrait, isClub } = usePoisBountyContext();

	const onHandleClick = () => {
		navigate("/shop");
		dispatch(onScrollToShopSection("Featured Deals"));
		toggleDrawer(false);
		const timeLeft = getTimeLeft(nowTime, tracker?.endTime, "seconds");
		const timeTotal =
			getTimeLeft(tracker?.startTime, tracker?.endTime, "seconds") || undefined;
		reportPlaygamiEvent("tp.web_frontend", {
			event_name: "continue_shopping_click",
			event_type: "pois_bounty_v3",
			action: "continue_shopping_click",
			source: "pois_bounty_v3",
			section_name: "/shop",
			type: tracker?.eventType === "user" ? "personal" : tracker?.eventType,
			time_left: timeLeft,
			time_total: timeTotal,
			event_id: tracker?.eventId
		});
	};

	const purchasesCount = useMemo(() => {
		return Object.values(tracker?.purchases || {})?.filter(
			(p) => p?.userId === userTracker?.id
		)?.length;
	}, [Object.keys(tracker?.purchases || {})?.length]);

	const isMaxed = useMemo(() => {
		return purchasesCount >= Number(tracker?.clubMaxPurchasesPerCycle);
	}, [purchasesCount, tracker?.clubMaxPurchasesPerCycle]);

	if (isPortrait) {
		return (
			<ToShopSectionMobile>
				{isClub && tracker?.clubMaxPurchasesPerCycle ? (
					<>
						<p>
							Loyalty Points from purchases
							<br /> contribute to Poi’s Bounty!
							<br />
							<span>
								Max {tracker.clubMaxPurchasesPerCycle}{" "}
								{tracker.clubMaxPurchasesPerCycle > 1
									? "purchases"
									: "purchase"}{" "}
								per user.
							</span>
						</p>
						<PurchaseCounter isMaxed={isMaxed} isPageVariant={isPageVariant}>
							{purchasesCount}/{tracker.clubMaxPurchasesPerCycle}{" "}
							{tracker.clubMaxPurchasesPerCycle > 1 ? "purchases" : "purchase"}
						</PurchaseCounter>
					</>
				) : (
					<p>
						Purchase items in the shop
						<br /> during the event and collect
						<br /> Loyalty Points.
					</p>
				)}
				<div className="shop-section-divider">
					<ButtonStyled onClick={onHandleClick}>To Shop</ButtonStyled>
					<img
						src={getImage(poisBountyAssets.v2.toShop.eventCompleted)}
						alt="Poi to shop image"
					/>
				</div>
			</ToShopSectionMobile>
		);
	} else {
		return (
			<ToShopSectionDesktop
				className={classNames([!isPageVariant && "mega-menu-variant"])}
				isClub={isClub && !!tracker?.clubMaxPurchasesPerCycle}
			>
				<img
					src={getImage(poisBountyAssets.v2.toShop.eventCompleted)}
					alt="Poi event completed image"
				/>
				{isClub && tracker?.clubMaxPurchasesPerCycle ? (
					<>
						{isPageVariant ? (
							<>
								<PurchaseCounter
									isMaxed={isMaxed}
									isPageVariant={isPageVariant}
								>
									{purchasesCount}/{tracker.clubMaxPurchasesPerCycle}{" "}
									{tracker.clubMaxPurchasesPerCycle > 1
										? "purchases"
										: "purchase"}
								</PurchaseCounter>
								<p>
									Loyalty Points from purchases contribute to Poi’s Bounty!
									<br />
									<span>
										Max {tracker.clubMaxPurchasesPerCycle}{" "}
										{tracker.clubMaxPurchasesPerCycle > 1
											? "purchases"
											: "purchase"}{" "}
										per user.
									</span>
								</p>
							</>
						) : (
							<p>
								Loyalty Points from purchases contribute to Poi’s Bounty!
								<br />
								<span>
									Max {tracker.clubMaxPurchasesPerCycle}{" "}
									{tracker.clubMaxPurchasesPerCycle > 1
										? "purchases"
										: "purchase"}{" "}
									per user.
								</span>
							</p>
						)}
					</>
				) : (
					<p>
						{isPageVariant ? (
							<>
								Purchase items in the shop during the event
								<br /> and collect Loyalty Points.
							</>
						) : (
							<>
								Purchase items in the shop during the event and collect Loyalty
								Points.
							</>
						)}
					</p>
				)}

				<ButtonStyled onClick={onHandleClick}>To Shop</ButtonStyled>
			</ToShopSectionDesktop>
		);
	}
};
